var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "lo-btn lo-btn--secondary lo-btn--lg lo-btn--expand",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
      },
    },
    [_c("span", { domProps: { innerHTML: _vm._s(_vm.text) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }